import {
    Component,
    EventEmitter,
    forwardRef,
    Input,
    Output,
} from '@angular/core';
import { ISegmentedOption } from '@pf/shared-common';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'pf-segmented',
    templateUrl: './segmented.component.html',
    styleUrls: ['./segmented.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SegmentedComponent),
            multi: true,
        },
    ],
    standalone: false,
})
export class SegmentedComponent implements ControlValueAccessor {
    private _model: string | number | null = null;

    @Input()
    set model(value: string | number | null) {
        if (this._model !== value) {
            if (typeof value === 'number') {
                value = this.segmentedOptions[value]?.value || value;
            }
            this._model = value;
            this.onChange(value);
            this.handleModelChange(value);
        }
    }

    get model(): string | number | null {
        return this._model;
    }

    @Input()
    segmentedOptions: ISegmentedOption[] = [];
    @Input() pfTitle?: string;

    @Output()
    selectedModelChange = new EventEmitter<number>();

    handleModelChange(value: string | number | null): void {
        if (!value) {
            return;
        }
        const index = this.segmentedOptions.findIndex(
            option => option.value === value
        );
        this.selectedModelChange.emit(index);
        this.onTouched();
    }

    writeValue(value: number | null): void {
        this.model = value;
    }

    registerOnChange(fn: (value: string | number | null) => void): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    private onChange: (value: string | number | null) => void = () => {
        // do nothing
    };
    private onTouched: () => void = () => {
        // do nothing
    };
}
